export default {"src":"/_next/static/media/functional-testing.9d81e386.svg","height":512,"width":448,"blurWidth":0,"blurHeight":0};